// Action Types
export const SUBMIT_COMPETITOR_PROFILE_V4_REQUEST =
  "SUBMIT_COMPETITOR_PROFILE_V4_REQUEST";
export const SUBMIT_COMPETITOR_PROFILE_V4_SUCCESS =
  "SUBMIT_COMPETITOR_PROFILE_V4_SUCCESS";
export const SUBMIT_COMPETITOR_PROFILE_V4_FAILURE =
  "SUBMIT_COMPETITOR_PROFILE_V4_FAILURE";

// Action Creators
export const submitCompetitorProfileV4Request = (formData) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V4_REQUEST,
  payload: formData,
});

export const submitCompetitorProfileV4Success = (message) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V4_SUCCESS,
  payload: message,
});

export const submitCompetitorProfileV4Failure = (error) => ({
  type: SUBMIT_COMPETITOR_PROFILE_V4_FAILURE,
  payload: error,
});
